import { i18n } from '@fishx/i18n';
import {
  getClients,
  addClient,
  deleteClient,
  updateClient,
} from '@pages/Oauth2ClientMgr/services/client';
import { message } from '@whalecloud/fdx';

export default {
  namespace: 'clientMgr',
  state: {
    clientList: [],
    selectItem: {},
  },
  effects: {
    *getClients(_, { call, put }) {
      const { success, data } = yield call(getClients);
      const newData = [];
      if (success) {
        if (data.length > 0) {
          data.forEach(v => {
            const i = v;
            i.clientSecret = '******';
            newData.push(i);
          });
        }
        yield put({
          type: 'save',
          payload: newData,
        });
        return newData;
      }
      return null;
    },
  
    *deleteClient({ payload }, { call, put }) {
      const { clientId } = payload;
      const { success } = yield call(deleteClient, clientId);
      if (success) {
        message.success(i18n('CLIENTMGR_DELETE_CLIENT_SUCCESS'));
        yield put({
          type: 'getClients',
          payload: {},
        });
        return;
      }
      message.error(i18n('CLIENTMGR_DELETE_CLIENT_FAILED'));
    },
      
    *addClient({ payload }, { call, put }) {
      const { success } = yield call(addClient, payload);
      if (success) {
        message.success(i18n('CLIENTMGR_ADD_CLIENT_SUCCESS'));
        yield put({
          type: 'getClients',
          payload: {},
        });
        return;
      }
      message.error(i18n('CLIENTMGR_ADD_CLIENT_FAILED'));
    },

    *updateClient({ payload }, { call, put }) {
      const { clientSecret } = payload;
      let newPayload = {};
      if (clientSecret === '******') {
        newPayload = {
          ...payload,
          clientSecret: null,
        };
      } else {
        newPayload = payload;
      }
      const { success } = yield call(updateClient, newPayload);
      if (success) {
        message.success(i18n('CLIENTMGR_MODIFY_CLIENT_SUCCESS'));
        yield put({
          type: 'getClients',
          payload: {},
        });
        return;
      }
      message.error(i18n('CLIENTMGR_MODIFY_CLIENT_FAILED'));
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        clientList: payload,
        selectItem: payload[0],
      };
    },
    clearData(state) {
      // 重置搜索
      return {
        ...state,
        list: [],
      };
    },
  },
};
